import { pList } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { rGrupSirket } from '../../../../api/models/rGrupSirket';
import rList from '../../../../api/models/rList';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_GRUPSIRKETLISTELE,
    new Api.Veri.GrupSirketListele().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rList<rGrupSirket> | null | undefined,
  error: IError | null | undefined
): IApiAction<rGrupSirket[]> =>
  ActionFunctions.action_async_complete_api<rGrupSirket[]>(
    ActionSubTypes.API_GRUPSIRKETLISTELE,
    data?.Values,
    error
  );
